import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useLogin } from 'hooks/useLogin';
import { uiActions } from 'store/uiSlice';

import LoginModal from 'components/LoginModal/LoginModal';

import './style.scss';

const LoginPage = () => {
  const login = useLogin();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const redirectTarget = urlParams.get('t')?.replace(' ', '+');

    if (login.isLoggedIn() && redirectTarget) {
      login.cleanUserLoginData();
      dispatch(uiActions.setTokenLoading(false));

      navigate(`./?t=${redirectTarget}`);
    }

    if (login.isLoggedIn()) {
      navigate(`/`);
    }
  }, [login, navigate, dispatch]);

  return login.isLoggedIn() ? null : (
    <div
      id="loginPage"
      style={{
        background: `url('./assets/images/login-bg.jpg') center center / cover no-repeat`
      }}
    >
      <div
        style={{
          width: '50%'
        }}
      ></div>
      <img
        className="logo"
        alt="logo"
        src={`./assets/images/full-logo-black.svg`}
        style={{ marginBottom: '30px' }}
      />
      <LoginModal />
    </div>
  );
};

export default LoginPage;
